import React from 'react';
import PropTypes from 'prop-types';
import { gettext } from '@eb/i18n';
import { NotificationBar } from '@eb/eds-notification';
import { TYPE_ERROR } from '@eb/eds-notification';

import { CoyoteProgressIndicator } from '../progressIndicator';

const _isPermissionFailure = (failure) => {
    const { response } = failure || {};

    return response && response.status === 403;
};

export default class LoadWithPermission extends React.Component {
    static propTypes = {
        load: PropTypes.func.isRequired,
        isLoaded: PropTypes.bool,
        onPermissionError: PropTypes.func,
    };
    state = {
        hasPermissionError: false,
    };
    componentDidMount() {
        const { load } = this.props;

        load().catch(this._handleLoadFailure);
    }
    _handleLoadFailure = (failure) => {
        if (_isPermissionFailure(failure)) {
            const { onPermissionError } = this.props;

            this.setState(() => ({ hasPermissionError: true }));
            if (onPermissionError) {
                onPermissionError();
            }
        }
    };
    render() {
        const { hasPermissionError } = this.state;
        const { children, isLoaded } = this.props;

        let content = isLoaded ? (
            children
        ) : (
            <CoyoteProgressIndicator
                style="gradient"
                data-spec="new-create-progress-indicator"
            />
        );

        if (hasPermissionError) {
            content = (
                <NotificationBar
                    type={TYPE_ERROR}
                    data-spec="permission-notification"
                >
                    {gettext(
                        'You do not have permission to complete this action. Please contact your account administrator to request access.',
                    )}
                </NotificationBar>
            );
        }

        return content;
    }
}
